import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Sparkles, Megaphone, HandCoins, Landmark, LineChart, ListChecks, Layers,
} from "lucide-react";

export const SIMPLE_NAV = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Home", testid: "snav-home" },
  { to: "/ask-totalreach", icon: Sparkles, label: "Ask TotalReach", testid: "snav-ask", badge: "AI" },
  { to: "/advertise", icon: Megaphone, label: "Advertise", testid: "snav-advertise" },
  { to: "/fundraise", icon: HandCoins, label: "Fundraise", testid: "snav-fundraise" },
  { to: "/race", icon: Landmark, label: "Race", testid: "snav-race" },
  { to: "/performance", icon: LineChart, label: "Performance", testid: "snav-performance" },
  { to: "/operations", icon: ListChecks, label: "Operations", testid: "snav-operations" },
  { to: "/more-tools", icon: Layers, label: "More Tools", testid: "snav-more-tools" },
];

export const SimpleNavList = () => (
  <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-testid="simple-sidebar-nav">
    {SIMPLE_NAV.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        end={item.to === "/dashboard"}
        data-testid={item.testid}
        className={({ isActive }) =>
          `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
            isActive
              ? "bg-gradient-to-r from-cyan-400/15 to-blue-500/10 text-cyan-300 border border-cyan-400/20"
              : "text-slate-300 hover:bg-white/5 hover:text-cyan-300 border border-transparent"
          }`
        }
      >
        <item.icon className="w-4 h-4 shrink-0" />
        <span className="flex-1">{item.label}</span>
        {item.badge && (
          <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-900 font-bold">
            {item.badge}
          </span>
        )}
      </NavLink>
    ))}
  </nav>
);

const BOTTOM_TABS = [SIMPLE_NAV[0], SIMPLE_NAV[1], SIMPLE_NAV[2], SIMPLE_NAV[3], SIMPLE_NAV[6]];

export const SimpleBottomBar = () => (
  <nav
    className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-sidebar/95 backdrop-blur-xl border-t border-white/10 flex items-stretch"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    data-testid="simple-bottom-bar"
  >
    {BOTTOM_TABS.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        end={item.to === "/dashboard"}
        data-testid={`bottombar-${item.testid}`}
        className={({ isActive }) =>
          `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] transition-colors ${
            isActive ? "text-cyan-300" : "text-slate-400"
          }`
        }
      >
        <item.icon className="w-5 h-5" />
        {item.label === "Ask TotalReach" ? "Ask AI" : item.label}
      </NavLink>
    ))}
  </nav>
);
